/** セル表示の共通フォーマッタ。 */

/** null/undefined を "-" にする表示用文字列（空文字も "-"）。 */
export const displayOrDash = (
  value: string | number | null | undefined
): string =>
  value === null || value === undefined || value === "" ? "-" : String(value);

/**
 * 数値を ja-JP の桁区切り（小数は維持）で整形し、単位を付す。
 * null/undefined は "-"。
 * 例: formatWithUnit(12345.6, "㎡") => "12,345.6 ㎡" / formatWithUnit(145000, "円/㎡") => "145,000 円/㎡"
 */
export const formatWithUnit = (
  value: number | null | undefined,
  unit: string
): string =>
  value === null || value === undefined
    ? "-"
    : `${value.toLocaleString("ja-JP")} ${unit}`;
